import Home from "../pages/Home";

const WebRoutes = [
    { path: "/home", exact: true, name: "home", component: Home },
    { path: "/", exact: false, name: "home", component: Home },
];

export default WebRoutes;